import { makeStyles } from "@mui/styles";
import { lighten, Theme } from "@mui/material";

export default makeStyles<Theme>(({ palette }) => ({
  groupRoot: {
    backgroundColor: lighten(palette.primary.main, 0.9),
  },
  oldPriceTextRoot: {
    color: palette.error.main,
    textDecoration: "line-through",
  },
}));
